import { Controller } from "remult";

@Controller("category-methods")
export class CategoryMethods {}
